<template>
  <el-form class="calc-str-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="expression">
      <template slot="label">
        <span class="require-flag">*</span>
        关联文本
      </template>
      <normal-select
        style="margin-top: 4px"
        :select-list="selectList"
        :selected-item="control.expression"
        @handle-select="associationSelect"
      ></normal-select>
      <map-input-list v-if="control.expression" :option-values="optionValues"></map-input-list>
    </el-form-item>
    <el-form-item prop="optionDefaultVal">
      <template slot="label">
        <span class="require-flag">*</span>
        默认赋值
      </template>
      <el-input v-model="control.optionDefaultValue"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { canCalcFieldTypes } from "~/data/sheet"
import { decorateSheet } from "@/utils/sheet"
import MapInputList from "@/components/UIComponents/MapInputList"

export default {
  name: "calc-str-control",
  components: {
    NormalSelect,
    MapInputList
  },
  props: {
    control: Object,
    fields: Array
  },
  data() {
    return {
      canCalcFieldTypes,
      optionValues: []
    }
  },
  computed: {
    decoratedSheet() {
      return decorateSheet({ controls: this.fields })
    },
    selectList() {
      return this.decoratedSheet.controls
        .filter(control => control._dataType === "string")
        .map(control => ({ label: control.name, value: control._cid }))
    }
  },
  created() {
    this.getOptionValues()
  },
  watch: {
    optionValues: {
      handler(newValue) {
        if (Object.keys(newValue).length != 0) {
          const result = {}
          newValue.forEach(item => {
            result[item.key] = item.value
          })
          this.$set(this.control, "optionValueMap", Object.assign({}, result))
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getOptionValues() {
      this.optionValues = this._.keys(this.control.optionValueMap).map(key => ({
        key: key,
        value: this.control.optionValueMap[key]
      }))
    },
    associationSelect(val) {
      this.control.expression = val?.value
    }
  }
}
</script>

<style lang="scss" scoped></style>
